"use strict";

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Represents a namespace inside the Security Token that handles a set of related functionality
 */

var SubModule =
/**
 * Create a new SubModule instance
 */
function SubModule(securityToken, context) {
  _classCallCheck(this, SubModule);

  this.securityToken = securityToken;
  this.context = context;
};

exports.SubModule = SubModule;